export default __webpack_public_path__ + "static/ay-glossary-knowledge-desk-refresh-icon-6e0730af11592a92ae64233dab2e22f2.svg";